import React, { useState } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
  const [menuIcon, setMenuIcon] = useState(false);
  const handleMenuIcon = () => {
    setMenuIcon(!menuIcon);
  };
  return (
    <nav className="navbarItems">
      <span className="logo">
        <i className="fa-solid fa-bolt"></i>
        <span className="logo-title" onClick={() => navigate("/")}>
          F & S Electric
        </span>
      </span>
      <div className="menuIcon" onClick={handleMenuIcon}>
        <i className={menuIcon ? "fas fa-times" : "fa-solid fa-bars"}></i>
      </div>
      <ul className={menuIcon ? "menu-item active" : "menu-item"}>
        <li onClick={() => navigate("/")}>
          <i className="fa-solid fa-house"></i>Home
        </li>
        <li onClick={() => navigate("/about")}>
          <i className="fa-solid fa-circle-info"></i>About
        </li>
        <li onClick={() => navigate("/product")}>
          <i className="fa-brands fa-product-hunt"></i>Product
        </li>
        <li onClick={() => navigate("/contact")}>
          <i className="fa-solid fa-address-book"></i>Contact
        </li>
      </ul>
    </nav>
  );
}

export default Header;
